import $ from 'jquery';
import Selectize from 'selectize';

Selectize.define('multiple_select_toggle_option', function () {

    // Behavior in browsers Google Chrome (v.66.0.3359.181 ) and Firefox Quantum(60.0.1) different.
    // Consistently performed 'mousedown' and 'click'.
    // A 'lastFiredEventType' is introduced to check the event
    let toggleOption = function (thisRef) {
        let self = thisRef;
        let lastFiredEventType = '';

        // Copied the original method Selectizi
        const selectOption = ($target, evt) => {
            if ($target.hasClass('create')) {
                self.createItem(null, () => {
                    if (self.settings.closeAfterSelect) {
                        self.close();
                    }
                });

                return;
            }

            const value = $target.attr('data-value');

            if (typeof value === 'undefined') {
                return;
            }

            self.lastQuery = null;
            self.setTextboxValue('');
            self.addItem(value);

            if (self.settings.closeAfterSelect) {
                self.close();
            } else if (!self.settings.hideSelected && evt.type && /mouse/.test(evt.type)) {
                self.setActiveOption(self.getOption(value));
            }
        };

        const deselectOption = ($target) => {
            const value = $target.attr('data-value');

            if (typeof value === 'undefined') {
                return;
            }

            self.lastQuery = null;
            self.setTextboxValue('');
            self.removeItem(value);

            if (self.settings.closeAfterSelect) {
                self.close();
            }
        };

        /**
         * Overriding the original method to provide toggle option functionality.
         *
         * @param {object} evt
         */
        thisRef.onOptionSelect = function (evt) {
            if (lastFiredEventType === '') {
                lastFiredEventType = evt.type;
            }

            if (lastFiredEventType !== evt.type) {
                return;
            }

            if (evt.preventDefault) {
                evt.preventDefault();
                evt.stopPropagation();
            }

            const $target = $(evt.currentTarget);

            if (!evt.currentTarget._isSelected) {
                evt.currentTarget._isSelected = true;
                selectOption($target, evt);
            } else {
                evt.currentTarget._isSelected = false;
                deselectOption($target);
            }
        };
    };

    toggleOption(this);
});
